// Central editable configuration for INRISOFT.
// Content migrated from the HTML website — layout/design stays in React components.

export { CLIENTS } from "./clients";

export const BRAND = {
  name: "INRISOFT",
  legal: "Inri Software Private Limited",
  tagline: "Ideas to Live Under One Roof",
  shortTagline: "We Build Software at the Speed of Ideas",
};

export const STATS = [
  { value: 400, suffix: "+", label: "Projects Completed" },
  { value: 10, suffix: "+", label: "Years of Experience" },
  { value: 18, suffix: "+", label: "Team Members" },
  { value: 20, suffix: "+", label: "Products" },
];

export const CONTACT_DETAILS = {
  location:
    "INRI Software Private Limited, Regus Business Center, Level 3, Vm Towers, Suchitra Rd, Green Park, Hyderabad, Telangana 500067",
  phone: "+91 9949143133",
  hours: "Mon–Sat, 9:00 AM – 6:00 PM (IST)",
  email: "info@inrisoft.com",
  emailNote: "Also: sales@inrisoft.com",
  salesEmail: "sales@inrisoft.com",
  mapEmbed:
    "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3805.3!2d78.48!3d17.52!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zSHlkZXJhYmFk!5e0!3m2!1sen!2sin!4v1700000000000",
};

export const OFFICES = [
  {
    region: "UAE",
    address: "Khalid Shaban Building, Office 493, Garhoud, Dubai",
    email: "info@inrisoft.com | sales@inrisoft.com",
    phone: "+91 9949143133",
  },
  {
    region: "India",
    address:
      "Regus Business Center, Level 3, Vm Towers, Suchitra Rd, Green Park, Hyderabad, Telangana 500067",
    email: "sales@inrisoft.com",
    phone: "+91 9949143133",
  },
  {
    region: "Latin America",
    address: "Inrisoft Chile — Chile Head of Corporate Products",
    contact: "Juan M. Callegaris V.",
    email: "juan@inrisoft.cl",
    phone: "+569 6749 4526",
    website: "https://inrisoft.com/",
  },
];

export const HERO_SLIDES = [
  {
    image: "/images/hero-skyline.jpg",
    label: "400+ Global Clients",
    headline: ["We Build Software", "At the Speed", "of Ideas."],
    text: "INRISOFT develops, designs and delivers websites, apps and creative campaigns that drive results — across Healthcare, Education, Logistics, Travel, Manufacturing, Fintech and more.",
  },
  {
    image: "/images/gcc-city.jpg",
    label: "USA | Europe | UK | Canada | Middle East | Asia",
    headline: ["Hyper Support", "Is Real.", "400+ Projects."],
    text: "Delivered close to 400 projects to clients across the globe with a hyper-support model — so you focus on business while we take care of software.",
  },
  {
    image: "/images/dubai-tower.jpg",
    label: "Digital Experiences",
    headline: ["Building Digital", "Presence With", "Emotional Impact."],
    text: "From MERN, MEAN and LAMP to PWA and hybrid apps — proven, reliable, robust and scalable tech stacks for products that go live and stay supported.",
  },
];

export const INSIGHTS = [
  {
    category: "Product",
    title: "From Idea to Live: Shipping Software Faster",
    excerpt:
      "How Inrisoft moves from Sprint Zero (POC) to go-live with empathy, design and continuous hyper support.",
    date: "2026",
  },
  {
    category: "Technology",
    title: "Emerging Tech: IoT, AI and AR/VR in Practice",
    excerpt:
      "Practical applications of IoT automation, AI analytics and immersive AR/VR across industries we serve.",
    date: "2026",
  },
  {
    category: "Consulting",
    title: "Choosing the Right Stack: MERN, MEAN, LAMP & PWA",
    excerpt:
      "Advisory guidance on architecture, platform selection and digital transformation for growing businesses.",
    date: "2025",
  },
  {
    category: "Delivery",
    title: "Hyper Support After Go-Live",
    excerpt:
      "Why after-sales support matters — and how we keep products secure, performant and evolving with your business.",
    date: "2025",
  },
];

export const SOCIALS = {
  linkedin: "https://www.linkedin.com/company/inrisoft",
  instagram: "https://www.instagram.com/inrisoft/?hl=en",
  facebook: "https://www.facebook.com/Inrisoft/",
  twitter: "https://twitter.com/inrisoft?lang=en",
};

export const SERVICES = [
  {
    id: "application-development",
    icon: "Smartphone",
    title: "Application Development (Mobile | Web)",
    badge: "40+ Apps",
    desc: "High-performance mobile and web apps tailored to business needs — custom iOS & Android, responsive web, PWA, UI/UX, cross-platform and API integration.",
  },
  {
    id: "product-development",
    icon: "Package",
    title: "Product Development (Mobile | Web)",
    badge: "Idea to Live",
    desc: "End-to-end product development from concept to launch — scalable, secure and UX-focused custom mobile & web apps with agile delivery.",
  },
  {
    id: "software-consulting",
    icon: "ClipboardList",
    title: "Software Consulting and Advisory",
    badge: "10+ Years Experience",
    desc: "Strategic technology roadmaps, architecture, platform selection, process optimization and industry-specific digital transformation guidance.",
  },
  {
    id: "emerging-technologies",
    icon: "Cpu",
    title: "Emerging Technologies — IoT, AI, AR/VR",
    badge: "Many Case Studies",
    desc: "Smart devices, intelligent automation and immersive experiences — IoT, AI analytics and AR/VR solutions with real case studies.",
  },
  {
    id: "managed-website",
    icon: "Globe2",
    title: "Managed Website Development",
    badge: "Go-Live Today!",
    desc: "Design, build and maintain websites with ongoing support — custom development, security, performance optimization and go-live readiness.",
  },
  {
    id: "it-consulting",
    icon: "Workflow",
    title: "IT Consulting | Strategy | Implementation",
    badge: "2 Decades of Exposure",
    desc: "Tailored IT strategies, analysis of challenges and opportunities, and end-to-end implementation aligned to business objectives.",
  },
];

export const WHY_FEATURES = [
  {
    icon: "Briefcase",
    title: "Speed of Ideas",
    desc: "We build software at the speed of ideas — from Sprint Zero POC to production with clear milestones.",
  },
  {
    icon: "ShieldCheck",
    title: "Hyper Support",
    desc: "After-sales hyper support so customers focus on business while we take care of software.",
  },
  {
    icon: "Layers",
    title: "Proven Stacks",
    desc: "MERN, MEAN, LAMP, PWA and hybrid stacks — proven, reliable, robust and scalable.",
  },
  {
    icon: "Zap",
    title: "Global Delivery",
    desc: "400+ projects delivered across USA, Europe, UK, Canada, Middle East, Asia, Australia and Africa.",
  },
  {
    icon: "Handshake",
    title: "True Partnerships",
    desc: "We believe in partnerships based on honesty and true connection — clients stay with us for years.",
  },
];

export const PROCESS = [
  {
    no: "01",
    title: "Listen",
    desc: "We spend time with clients to discuss requirements and understand business goals.",
  },
  {
    no: "02",
    title: "Educate & Strategise",
    desc: "We empathize, design for end-user needs, ideate and construct a Sprint Zero (POC).",
  },
  {
    no: "03",
    title: "Develop & Launch",
    desc: "We test thoroughly and go live with secure, high-performance software.",
  },
  {
    no: "04",
    title: "Maintain",
    desc: "We provide after-sales hyper support so you focus on business while we care for software.",
  },
];

export const INDUSTRIES = [
  { icon: "Stethoscope", name: "Healthcare", desc: "Clinical platforms, IoT health devices and compliant applications." },
  { icon: "GraduationCap", name: "Education", desc: "EdTech apps, LMS, ERP and multi-school management systems." },
  { icon: "Truck", name: "Logistics", desc: "Operations, tracking and supply-chain software solutions." },
  { icon: "Plane", name: "Travel", desc: "Booking, operations and customer experience platforms." },
  { icon: "Factory", name: "Manufacturing", desc: "ERP, production planning, inventory and reporting systems." },
  { icon: "Landmark", name: "Fintech", desc: "Secure financial products, CRM and transaction platforms." },
  { icon: "Scale", name: "Legal", desc: "Practice and compliance-oriented digital solutions." },
  { icon: "Pill", name: "Pharma", desc: "Industry software for operations, tracking and engagement." },
  { icon: "Cpu", name: "IT & ICT", desc: "Custom software, consulting and digital transformation." },
];

export const TESTIMONIALS = [
  {
    quote:
      "We believe in creating partnerships based on honesty and true connection. That's why some of the biggest companies stayed with us for years.",
    name: "INRISOFT Clients",
    title: "Long-term Partnerships",
    company: "Global Portfolio",
  },
  {
    quote:
      "Delivered close to 400 projects to clients across the globe — with hyper support so teams can focus on business while software stays reliable.",
    name: "Project Delivery",
    title: "Hyper Support Model",
    company: "INRISOFT",
  },
  {
    quote:
      "We Listen, Educate, Strategise, Develop, Correct, Launch and Maintain — a clear path from idea to live product.",
    name: "Delivery Approach",
    title: "End-to-End Process",
    company: "INRISOFT",
  },
];

export const LOCATIONS = [
  "USA",
  "Europe",
  "UK",
  "Canada",
  "Middle East",
  "Asia",
  "Australia",
  "Africa",
];

export const TECH_STACK = [
  "PHP",
  "JAVA",
  "JavaScript",
  "ReactJS",
  "React Native",
  "NEXT.JS",
  "Node.Js",
  "Express",
  "Redux",
  "TypeScript",
  "VUE.Js",
  "Angular",
  ".NET",
  "ASP.NET",
  "AWS",
  "Docker",
  "MongoDB",
  "MySql",
  "PostgreSQL",
  "Microsoft Azure",
  "GraphQL",
  "Kafka",
];

export const PRICING_PLANS = [
  {
    id: "managed-website",
    title: "Managed Website Services and Products",
    price: "₹500",
    period: "per month",
    featured: false,
    features: [
      "15-25 pages",
      "Security (SSL)",
      "Website and CMS",
      "Self-Configurable",
      "Training Videos",
      "Social Media integration",
      "Fast Server",
      "Fully Dynamic",
      "Annual Maintenance",
      "Mobile Friendly Site",
    ],
  },
  {
    id: "android-app",
    title: "Android App Development",
    price: "₹1000",
    period: "per month",
    featured: true,
    features: [
      "15-25 Screens",
      "Security (SSL)",
      "App and CMS",
      "Self-Configurable",
      "Training Videos",
      "Social Media integration",
      "Fast Server",
      "Fully Dynamic",
      "Annual Maintenance",
      "Mobile Friendly Site",
    ],
  },
  {
    id: "android-iphone",
    title: "Android + iPhone Apps Development",
    price: "₹1500",
    period: "per month",
    featured: false,
    features: [
      "15-25 Screens",
      "Security (SSL)",
      "App and CMS",
      "Self-Configurable",
      "Training Videos",
      "Social Media integration",
      "Fast Server",
      "Fully Dynamic",
      "Annual Maintenance",
      "Mobile Friendly Site",
    ],
  },
];

export const PRIVACY_SECTIONS = [
  {
    title: "Introduction",
    body: "Inri Software Private Limited (\"Inrisoft\", \"we\", \"us\", or \"our\") is committed to protecting your privacy. This Privacy Policy explains how we collect, use, share, and protect your personal information when you use our software, website, and related services (\"Services\"). By using our Services, you agree to this Privacy Policy. If you do not agree, please unsubscribe from our Services.",
  },
  {
    title: "Information We Collect",
    body: "Personal Information: information that can identify you as an individual, such as Name, Phone, and Email. Non-Personal Information: data that cannot directly identify you, including device information (IP address, browser type, operating system), usage data (pages visited, time spent, clicks), and cookies / tracking technologies.",
  },
  {
    title: "How We Use Your Information",
    body: "We use collected information to provide and maintain our Services; improve quality and performance; communicate updates, promotions, and support; and comply with legal obligations.",
  },
  {
    title: "Legal Compliance",
    body: "We may disclose your information if required by law or by public authorities.",
  },
  {
    title: "Business Transfers",
    body: "In the event of a merger, acquisition, or asset sale, your information may be transferred. We will notify you of any such change.",
  },
  {
    title: "Data Security",
    body: "We use encryption, firewalls, and secure access controls to protect your data. However, no method of transmission over the Internet is completely secure.",
  },
  {
    title: "Cookies and Tracking Technologies",
    body: "We use cookies and similar technologies. You can refuse cookies, though some features of the Services may be limited.",
  },
  {
    title: "Third-Party Links",
    body: "Our Services may contain links to third-party sites. We are not responsible for their privacy practices.",
  },
  {
    title: "Contact Us",
    body: "Inri Software Private Limited — info@inrisoft.com | inrisoft@gmail.com",
  },
];

export const TERMS_SECTIONS = [
  {
    title: "Introduction",
    body: "These Terms and Conditions govern your use of the application and website, www.inrisoft.com, provided by Inri Software Private Limited. By using the application, you agree to these Terms and Conditions, including the Privacy Policy, which together constitute a legally binding agreement between you and Inri Software Private Limited.",
  },
  {
    title: "Electronic Communications",
    body: "When you access the Application or communicate with the Company electronically, you consent to receive communications from us electronically, meeting any legal requirement for such communications to be in writing.",
  },
  {
    title: "User Responsibilities",
    body: "You agree to use the Application lawfully and comply with the User Agreement. You must be of the required minimum age if accessing certain sections of the Application, and you assume responsibility for any risks involved in using the Application. Access the Application only for lawful purposes and in compliance with applicable laws. Use the Application at your own risk and exercise prudent judgment before transactions.",
  },
  {
    title: "Modification of the User Agreement",
    body: "The Company may modify the terms at any time, notifying you through the Application or email. Continued use implies acceptance of these modifications.",
  },
  {
    title: "Governing Law and Jurisdiction",
    body: "The User Agreement shall be governed by Indian law. Disputes will be resolved through arbitration in Indore, India, under the Arbitration and Conciliation Act, 1996.",
  },
  {
    title: "Copyright & Trademark",
    body: "All materials on the Application are owned or licensed by the Company and protected by copyright and intellectual property law. No content from the Application may be reproduced or distributed without prior permission.",
  },
  {
    title: "Limitation of Liability",
    body: "The Application is provided \"as is\" without warranties or guarantees. The Company is not liable for any damages arising from your use of the Application.",
  },
  {
    title: "Entire Agreement",
    body: "The User Agreement is the complete agreement between you and the Company concerning the Application, superseding prior communications.",
  },
  {
    title: "Refund Policy",
    body: "Payments once made are non-refundable.",
  },
];

export const NAV_LINKS = [
  { label: "Home", to: "/" },
  { label: "About Us", to: "/about" },
  { label: "Services", to: "/services" },
  { label: "Products", to: "/products" },
  { label: "Industries", to: "/industries" },
  { label: "Our Clients", to: "/clients" },
  { label: "Contact", to: "/contact" },
];

export const IMAGES = {
  hero: "/images/hero.jpg",
  gcc: "/images/gcc-city.jpg",
  trust: "/images/trust.jpg",
  employers: "/images/employers.jpg",
  jobseekers: "/images/jobseekers.jpg",
};
